import { Component, OnInit, Input } from '@angular/core';
import { MediathequeComponent } from '../../../shared/mediatheque/mediatheque.component';
import { ApiService } from '../../../shared/api.service';
import { Router } from '@angular/router';
import { EventSendeurService } from '../../../shared/event-sendeur.service';
import { NbToastrService, NbDialogService, NbDialogRef } from '@nebular/theme';
import { DomSanitizer } from '@angular/platform-browser';
import { Article } from '../../../shared/data/article';
import { plainToClass } from 'class-transformer';
import { Config } from '../../../config/config';

@Component({
  selector: 'ngx-update-article',
  templateUrl: './update-article.component.html',
  styleUrls: ['./update-article.component.scss']
})
export class UpdateArticleComponent implements OnInit {
  @Input() id: number;
  @Input() type_art: string;
  model;
  /* description;
  slug;
  titre;
  datePublish; 
  heure = "15";
  minute = "22";*/
  article= new Article;
  hideButon = false;
  hideLoader = true;
  // tableau:any =[];
  isPublish = false;

  selectedItems = [];
  dropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'chemin',
    selectAllText: 'Selectionner tous',
    unSelectAllText: 'Déselectionner tout',
    itemsShowLimit: 3,
    allowSearchFilter: true,
    closeDropDownOnSelection: true,
  };

  filebrowserBrowseUrl =  '';
  filebrowserImageBrowseUrl = '';
  categories: any[];

  config = Config;

  // imageselect = '';
  
  constructor(private sanitizer: DomSanitizer,private dialogService: NbDialogService,protected dialogRef: NbDialogRef<UpdateArticleComponent>,private apiService:ApiService, private router:Router,private sendeurService:EventSendeurService, public toastr:NbToastrService ) { 
  
    this.model = this.article.converDatePublishToNgbDateStruct;

    this.getCategories();

    

  }

  getCategories(){

    this.apiService.getAllCategoryProvider('article').subscribe(data =>{
     

      this.categories = data as any[];
      /* const tmps = data as any[];   
      this.categories = tmps.map(tmp => {
        return {
        
          nom: tmp.nom,   
          id:tmp.id,
          description:tmp.description
        };
      
      }); */

    })
    
  }

  ngOnInit() {
  
    if(this.id !== 0)
    this.getOneArticle();

    // console.log(this.model);
  
    this.sendeurService.image.asObservable().subscribe(data =>{

      // this.imageChoisie = this.sanitizer.bypassSecurityTrustResourceUrl(data);

      // console.log(this.imageselect);

        this.article.photo = data;


    })

    
   
  }

 

  updateArticle(){
  
    if (this.article.photo === undefined || this.article.photo === null) {
      this.toastr.danger(" vous devez choisir une image");
      return false;
    }

    
    if(this.model!== undefined){
      this.article.date_publish = {
        "date": {
          "year": this.model.year,
          "month": this.model.month,
          "day": this.model.day 
        },
        "time": {
          "hour": 0,
          "minute": 0
        }
     } 
    } else {

      this.article.date_publish = null;

    }

    // console.log ( pro)

    this.hideButon = true;
    this.hideLoader = false;

    if(this.id !== 0) {

      this.apiService.updateArticleProvider(this.article).subscribe(data =>{
          //  console.log(data);
          const article = plainToClass( Article, data as object );
          this.dialogRef.close();
          article.editMode = 'update';
          this.sendeurService.article.next( article );
          this.toastr.success("mise à jour réussie", article.titre);
          /* localStorage.removeItem("fichier");
          this.sendeurService.sendPageEvent(6); */
        },(err) =>{
          console.log(err);
          this.toastr.danger(" echec de mise à jour , remplissez tous les champs ")
          this.hideButon = false;
          this.hideLoader = true;
          if(err.error.code ===401){
            localStorage.clear();
            window.location.reload();
            let link2 = ['/login'];
            this.router.navigate(link2);
          }

          if(err.error.code ===500){
            
              this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
          }
        })

      } else {

        this.article.type_article = this.type_art;

        this.apiService.addArticleProvider(this.article).subscribe(data =>{
            const article = plainToClass( Article, data as object );
            this.dialogRef.close();
            article.editMode = 'create';
            this.sendeurService.article.next( article );
            this.toastr.success("Crée avec success", article.titre);
            /* localStorage.removeItem("fichier");
            this.sendeurService.fichier.next(null);
            this.sendeurService.sendPageEvent(5); */
          },(err) =>{
          this.hideButon = false;
          this.toastr.danger("il se peut qu'un article porte déjà le meme nom", "erreur")
            console.log(err);
      
            if(err.error.code ===401){
            localStorage.clear();
            window.location.reload();
            let link2 = ['/login'];
            this.router.navigate(link2);
          }

      });

  }
  
  
  }


  addImage(){
  
    this.dialogService.open(MediathequeComponent, {context: { mime: 'image'}});
  }

  

  getOneArticle(){
    this.apiService.getOneArticleProvider(this.id).subscribe(data =>{

      this.article = plainToClass( Article, data as object);
      this.model = this.article.converDatePublishToNgbDateStruct;

      this.selectedItems = this.article.categories;

    },(err) =>{
      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }

      if(err.error.code ===500){
      
        this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
     }
    })
  }

  onItemSelect(item: any) {

    if( this.article.categories !== undefined){

      let itemIndex: number;
      itemIndex = this.article.categories.findIndex(itm => itm.id === item.id);

      if (itemIndex === -1)
      this.article.categories.push(item);

    } else {

      this.article.categories= [];
      this.article.categories.push(item);

    }
   
  }

  
  onItemDeSelect(item: any){

    let itemIndex: number;
    itemIndex = this.article.categories.findIndex(itm => itm.id === item.id);

    if (itemIndex > -1)
    this.article.categories.splice(itemIndex, 1);

  }

  onSelectAll(items: any) {
    
  }

  onDeSelectAll($event){
    
  }

  onUnSelectAll(){
    
  }

  onDropDownClose($event){
    
  }


  cancel(){
    this.dialogRef.close();
    this.sendeurService.fichier.next(null);
    
  }

  close(){
    this.dialogRef.close();
    this.sendeurService.fichier.next(null);
  }


}
